module.exports = __webpack_public_path__ + "img/home-banner-3.d6147b93.jpg";